import React from 'react';
import { Device } from '../../lib/types';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';

interface CancelTransferModalProps {
  open: boolean;
  onClose: () => void;
  device: Device | null;
  onConfirm: (device: Device) => void;
}

export default function CancelTransferModal({ open, onClose, device, onConfirm }: CancelTransferModalProps) {
  if (!device) {
    return null;
  }

  const currentDevice = device;

  function handleConfirm() {
    onConfirm(currentDevice);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>Cancel adoption transfer</ModalTitle>
      <ModalSubtitle>
        Cancel the pending adoption transfer for {device.id}
        {device.petName ? ` (${device.petName})` : ''}
        {device.adopterName ? ` to ${device.adopterName}` : ''}? The device will return to your rescue&rsquo;s
        inventory.
      </ModalSubtitle>
      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          Keep Transfer
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Cancel Transfer
        </Button>
      </ModalActions>
    </Modal>
  );
}
